export { SimpleLanding } from './SimpleLanding';
